export default __webpack_public_path__ + "static/media/microcentrifuge_lid_open.f796f8dc.svg";